import { memo } from "react";
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals";

const ExchangeTimingModal = () => {

    const dispatch = useDispatch();

    const exchangeTimings = useSelector(state => state?.appInfo?.exchangeTimings);

    const modals = useSelector(state => state?.modals?.modals);

    const handleClose = () => {
        dispatch(handleModal([{ "EXCHANGE_TIMING_MODAL": false }]));
    };


    return (
        <>

            <BzModal size='lg' show={modals['EXCHANGE_TIMING_MODAL']} onHide={handleClose} className='modal-breeze-lg'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>View Exchange Timings</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div data-testid="modal-close" onClick={handleClose} className='icon-16 icon-close icon-dark ms-3'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <table className='table table-hover table-striped bdr my-2'>
                        <thead>
                            <tr>
                                <th className='font-regular font-size2 table-th-color-text text-left col-md-4'>EXCHANGE</th>
                                <th className='font-regular font-size2 table-th-color-text text-center col-md-4'>MARKET TIMINGS</th>
                                <th className='font-regular font-size2 table-th-color-text text-center col-md-4'>AMO TIMINGS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                exchangeTimings.map((item, i) => {
                                    return (
                                        <tr key={i}>
                                            <td className='font-regular font-size2 table-td-color-subtext text-left text-uppercase col-md-4'>{item.ExchnageName}</td>
                                            <td className='font-regular font-size2 table-td-color-subtext text-center text-uppercase col-md-4'>{item?.Open?.slice(0, 5)} -&nbsp;
                                                {
                                                    item?.Close?.slice(0, 2) < 12 ? `${item?.Close?.slice(0, 5)} ` : `${item?.Close?.slice(0, 5)}`
                                                }
                                            </td>
                                            {!item.AmoOpen ?
                                                <td className='font-regular font-size2 table-td-color-subtext text-center text-uppercase col-md-4'>-</td> :
                                                <td className='font-regular font-size2 table-td-color-subtext text-center text-uppercase col-md-4'>
                                                    {
                                                        item?.AmoOpen?.slice(0, 2) < 12 ? `${item?.AmoOpen?.slice(0, 5)} - ` : `${item?.AmoOpen?.slice(0, 5)}  - `
                                                    }

                                                    {item?.AmoClose?.slice(0, 5)} 
                                                </td>}
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </BzModalBody>
            </BzModal>
        </>
    );
};

export default memo(ExchangeTimingModal);